/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Backtodashboard2Inputs */

const he_common_backtodashboard2 = /** @type {(inputs: Common_Backtodashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חזרה לדף הבית`)
};

const en_common_backtodashboard2 = /** @type {(inputs: Common_Backtodashboard2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Dashboard`)
};

/**
* | output |
* | --- |
* | "Back to Dashboard" |
*
* @param {Common_Backtodashboard2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_backtodashboard2 = /** @type {((inputs?: Common_Backtodashboard2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Backtodashboard2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_backtodashboard2(inputs)
	return en_common_backtodashboard2(inputs)
});
export { common_backtodashboard2 as "common_backToDashboard" }